module.exports = __webpack_public_path__ + "static/media/menuimage_oepnv.ffe32af9.jpg";